import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../data.service';

@Component({
  standalone: false,
  selector: 'app-all-referrals',
  templateUrl: './all-referrals.component.html',
  styleUrls: ['./all-referrals.component.css']
})
export class AllReferralsComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute,private dataService:DataService) {
    this.dataService.setShowPage(false);
   }

  ngOnInit() {
  }
  
  goToPrevApp(){
    this.router.navigate([this.dataService.getBaseUrl()+this.dataService.getData(this.dataService.getNum()-1).url]);
  }

  goToNextApp(){
    this.router.navigate([this.dataService.getBaseUrl()+this.dataService.getData(this.dataService.getNum()+1).url]);
  }

  getShowPage(){
    this.dataService.getShowPage();
  }

}
